import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Label processing Services
 * !== 라벨 처리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/ptl/lbl`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/ptl/lbl/lbl-lang`,
    nodes: [
        { path: "/", label: "L_LBL_MGMT" },
        { path: "/ptl/lbl", label: "L_LBL_MGMT" },
    ],
};

export const URLS = {
    ptli1014001q: `${BASE.path}/ptli1014001q`, // Label processing List !==  라벨 처리 목록 ==!
    ptli1014002s: `${BASE.path}/ptli1014002s`, // Label processing Registration !==  라벨 처리 등록 ==!
    ptli1014003s: `${BASE.path}/ptli1014003s`, // Modifying and deleting Label processing !==  라벨 처리 수정 및 삭제 ==!
};

export const APIS = {
    // Label processing List !==  라벨 처리 목록 ==!
    getLblLangList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Label processing information !==  라벨 처리 정보 조회 ==!
    getLblLang: (id: any) => {
        return api.get(`${BASE.api}/${id}`);
    },

    // Label processing information save !==  라벨 처리 정보 저장  ==!
    saveLblLang: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    //Label processing information delete  !==  라벨 처리 정보 삭제 ==!
    deleteLblLang: (lblId: any) => {
        return api.delete(`${BASE.api}/${lblId}`);
    },
};

export const SF_LBL_LANG_SRCH: TFormSchema = {
    id: "form_LblLangSrch",
    schema: {
        lblId: { type: "text", label: "L_LBL_ID", letterCase: "upper" },
        lblNm: { type: "text", label: "L_LBL_NM" },
        // bsopClsfCd: {
        //     type: "select",
        //     label: "L_BSOP_CLSF_CD",
        //     options: [
        //         { label: "Common", value: "COM" },
        //         { label: "Portal", value: "PTL" },
        //         { label: "Cargo", value: "CGM" },
        //         { label: "Clearance", value: "CLR" },
        //         { label: "Single Window", value: "ESW" },
        //     ],
        // },
        bsopClsfCd: { type: "select", label: "L_BSOP_CLSF_CD", all: true, area: "comnCd", comnCd: "COM0024" },
        lblTpCd: {
            type: "select",
            label: "L_LBL_TP_CD",
            options: [
                { label: "Label", value: "L" },
                { label: "Title", value: "T" },
                { label: "Button", value: "B" },
            ],
        },
    },
};

export const SF_LBL_LANG: TFormSchema = {
    id: "form_LblLang",
    schema: {
        lblId: {
            type: "text",
            label: "L_LBL_ID",
            letterCase: "upper",
            required: true,
            minLength: { value: 3, message: "라벨 아이디를 3자 이상 입력하세요." },
        },
        lblNmKo: { type: "text", label: "L_LBL_NM_KO", controlSize: 10, required: true },
        lblNmEn: { type: "text", label: "L_LBL_NM_EN", controlSize: 10, required: true },
        lblNmTz: { type: "text", label: "L_LBL_NM_TZ", controlSize: 10, required: true },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            required: true,
            all: true,
            area: "comnCd",
            comnCd: "COM0024",
        },
        // bsopClsfCd: {
        //     type: "select",
        //     label: "L_BSOP_CLSF_CD",
        //     required: true,
        //     options: [
        //         { label: "Common", value: "COM" },
        //         { label: "Portal", value: "PTL" },
        //         { label: "Cargo", value: "CGM" },
        //         { label: "Clearance", value: "CLR" },
        //         { label: "Single Window", value: "ESW" },
        //     ],
        // },
        lblTpCd: {
            type: "select",
            label: "L_LBL_TP_CD",
            select: false,
            required: true,
            options: [
                { label: "Label", value: "L" },
                { label: "Title", value: "T" },
                { label: "Button", value: "B" },
            ],
        },
        frstRegstId: { type: "text", label: "L_FRST_REGST_ID" },
        frstRgsrDtm: { type: "text", label: "L_FRST_RGSR_DTM" },
    },
};

export const SG_LBL_LANG_LIST: TGridSchema = {
    id: "grid_LblLangList",
    options: { pagination: "out", checkbox: true, index: true },
    head: [
        { cells: [{ header: "L_LBL_ID", binding: "lblId", width: "10%" }] },
        { cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCd", width: "10%" }] },
        { cells: [{ header: "L_LBL_TP_CD", binding: "lblTpCd", width: "10%" }] },
        { cells: [{ header: "L_LBL_NM_EN", binding: "lblNmEn", width: "*" }] },
        { cells: [{ header: "L_LBL_NM_TZ", binding: "lblNmTz", width: "*" }] },
        { cells: [{ header: "L_LBL_NM_KO", binding: "lblNmKo", width: "*" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "10%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "lblId" }] },
        { cells: [{ binding: "bsopClsfCd" }] },
        { cells: [{ binding: "lblTpCd" }] },
        { cells: [{ binding: "lblNmEn", align: "left" }] },
        { cells: [{ binding: "lblNmTz", align: "left" }] },
        { cells: [{ binding: "lblNmKo", align: "left" }] },
        { cells: [{ binding: "frstRegstId" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
    ],
};

export {};
